import script from "./CompetitionStandingsIndividual.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompetitionStandingsIndividual.vue?vue&type=script&lang=ts&setup=true"

import "./CompetitionStandingsIndividual.vue?vue&type=style&index=0&id=5869f52a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5869f52a"]])

export default __exports__